export default __webpack_public_path__ + "static/media/004-catapult.35f54c9c.svg";